import { useAuth } from "@clerk/react"
import { useQuery } from "@tanstack/react-query"
import { useMarketplaceOrpc } from "@/integrations/orpc"
import { moderationQueryKey } from "./use-moderation-cases"

export const moderationCountsQueryKey = [
	...moderationQueryKey,
	"counts",
] as const

export function useModerationCounts({
	enabled = true,
}: {
	enabled?: boolean
} = {}) {
	const { client } = useMarketplaceOrpc()
	const { isSignedIn } = useAuth()

	return useQuery({
		queryKey: moderationCountsQueryKey,
		queryFn: () => client.moderation.getCounts(),
		enabled: enabled && !!isSignedIn,
		staleTime: 30 * 1000,
		refetchInterval: 60 * 1000,
		refetchOnWindowFocus: true,
	})
}
